import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Space, Spin } from 'antd';
import { selectAgents, selectLoading, useContactStore } from 'stores/nic/stores/contactStore';
import { useNicService } from 'stores/nic/useNicService';
import { useCallStore } from 'stores/nic/stores/callStore';
import { DirectoryEntities } from '@nice-devone/common-sdk';
import { DirectoryNavigation } from './DirectoryNavigation';
import { AgentList } from './AgentList';
import { TeamList } from './TeamList';
import { SkillList } from './SkillList';
export var DirectoryType;
(function (DirectoryType) {
    DirectoryType["AGENTS"] = "agents";
    DirectoryType["TEAMS"] = "teams";
    DirectoryType["SKILLS"] = "skills";
})(DirectoryType || (DirectoryType = {}));
export var DirectoryComponent = function (_a) {
    var searchText = _a.searchText;
    var _b = useState(DirectoryType.AGENTS), activeType = _b[0], setActiveType = _b[1];
    var setCalls = useCallStore(function (state) { return state.setCalls; });
    var setAgentToCall = function (agent) { return setCalls({ index: 0, agentInfo: agent }); };
    var loading = useContactStore(selectLoading);
    var loadDirectoryData = useNicService().loadDirectoryData;
    useEffect(function () {
        var cleanup = loadDirectoryData({
            searchText: searchText,
            entity: [
                DirectoryEntities.AGENT_LIST,
                DirectoryEntities.SKILL_LIST,
                DirectoryEntities.TEAM_LIST
            ]
        });
        return function () {
            if (cleanup) {
                cleanup();
            }
        };
    }, [searchText]);
    var handleTypeChange = useCallback(function (type) {
        setActiveType(type);
    }, [setActiveType]);
    var agents = useContactStore(selectAgents);
    var renderContent = useMemo(function () {
        switch (activeType) {
            case DirectoryType.AGENTS:
                return _jsx(AgentList, { agents: agents, setAgentToCall: setAgentToCall });
            case DirectoryType.TEAMS:
                return _jsx(TeamList, { setAgentToCall: setAgentToCall });
            case DirectoryType.SKILLS:
                return _jsx(SkillList, {});
            default:
        }
    }, [activeType, agents]);
    return (_jsxs(Space, { orientation: "vertical", style: { width: '100%', minWidth: 500 }, size: "middle", children: [_jsx(DirectoryNavigation, { onTypeChange: handleTypeChange, activeType: activeType }), _jsx("div", { style: { maxHeight: '450px', overflowY: 'auto' }, children: _jsx(Spin, { spinning: loading, children: renderContent }) })] }));
};
export default DirectoryComponent;
